import React, { FC, useMemo } from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { nullSafeGet } from '../../utils/DataAccessUtils';

const EquipmentTypeWithIDDisplay: FC<any> = ({
	equipmentType,
	numberMaxChars,
	nameLengthPercentage,
}): React.ReactElement => {
	const ellipsisProps = useMemo(
		() => ({
			...(numberMaxChars ? { length: numberMaxChars } : { lines: 1 }),
		}),
		[numberMaxChars]
	);

	const equipmentTypeNumberText = useMemo(
		() =>
			`${
				nullSafeGet('equipmentTypeNumber', equipmentType)
					? `Equipment Type # ${equipmentType.equipmentTypeNumber}`
					: ''
			}`,
		[equipmentType]
	);

	return (
		<div
			className="flex flex-col"
			style={{
				...(nameLengthPercentage && { width: `${nameLengthPercentage}%` }),
			}}
		>
			<Ellipsis tooltip={true} lines={1}>
				{equipmentType.modelName || '--'}
			</Ellipsis>
			<Ellipsis tooltip={true} className="text-gray-400" {...ellipsisProps}>
				{equipmentTypeNumberText}
			</Ellipsis>
		</div>
	);
};

export default EquipmentTypeWithIDDisplay;
